// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2gCs0","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__17KaU"};